import { Intent } from "@blueprintjs/core";

import { AggregateState } from "@types";

export const getStatusInfo = (
  state: AggregateState
): {
  name: string;
  intent: Intent;
} => {
  if (state === "ignored-app" || state === "ignored-code") {
    return { name: "Ignored", intent: Intent.WARNING };
  }
  if (state === "fixed") {
    return { name: "Fixed", intent: Intent.NONE };
  }

  return {
    name: "Open",
    intent: Intent.SUCCESS,
  };
};
